import React from 'react';
import { Button } from 'react-bulma-components';
export const ActionButton = ({ ...rest }) => {
    return <Button style={{minWidth: 100}} {...rest} />

}